import React from "react";
import { AppBar, Toolbar, Typography, IconButton } from "@material-ui/core";
import BackArrow from "@material-ui/icons/ArrowBackRounded";
import { useStyles } from "./style";
import { useUtils } from "../../utils";
import Menus from "./menu";
import OrgAndGroupSelect from "./OrgAndGroupSelect";

function Header(props) {
  const { colors } = useUtils();
  const classes = useStyles(colors);
  const { attr = {}, history, options = [], onMenuClick, dash_name = "" } = props;
  const isAdminMode = window.location.pathname.startsWith("/admin");
  return (
    <AppBar className={classes.root} position="fixed">
      <Toolbar disableGutters>
        <div
          style={{
            display: "flex",
            flex: 1,
            marginLeft: 10,
            gap: 10,
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          {/* {attr.enableBack ? (
            <IconButton size="small" onClick={() => history.goBack()}>
              <BackArrow />
            </IconButton>
          ) : (
            null
          )} */}
          <Typography color="secondary" variant="body1" className={classes.title}>
            {dash_name} {attr.title}
          </Typography>
          {!isAdminMode ? <OrgAndGroupSelect /> : null}
        </div>
        {/* {otherComponents && otherComponents} */}
        {options.length > 0 && (
          <Menus
            options={options}
            history={history}
            onMenuSelect={(id) => {
              if (onMenuClick) onMenuClick(id);
            }}
          />
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
